(() => {
  const FORM_SELECTOR = '.cd13-search-page-form';
  const IGNORED_WORDS = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'en', 'pour', 'avec', 'sans', 'et', 'ou', 'a', 'au', 'aux', 'sur', 'dans', 'profil', 'profile', 'profiles', 'profils', 'prof']);

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const effectiveQuery = (value) => {
    const tokens = normalize(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .split(' ')
      .filter(Boolean)
      .map((token) => token.replace(/^(?:prof|profil|profile)(?=\d)/, ''))
      .filter((token) => token && !IGNORED_WORDS.has(token));
    return tokens.length ? tokens.join(' ') : String(value || '').trim();
  };

  const isReference = (value) => window.CD13ReferenceSearch?.isReference?.(value);

  function normalisePageUrl() {
    if (location.pathname !== '/search') return;
    const params = new URLSearchParams(location.search);
    const query = params.get('q') || '';
    if (!query || isReference(query)) return;
    const effective = effectiveQuery(query);
    if (!effective || normalize(effective) === normalize(query)) return;
    params.set('q', effective);
    location.replace(`${location.pathname}?${params.toString()}`);
  }

  function attach(form) {
    if (form.dataset.cd13SearchPageReady === 'true') return;
    form.dataset.cd13SearchPageReady = 'true';
    form.addEventListener('submit', () => {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      const query = input.value.trim();
      if (!query || isReference(query)) return;
      input.value = effectiveQuery(query);
    });
  }

  function initialise() {
    normalisePageUrl();
    document.querySelectorAll(FORM_SELECTOR).forEach(attach);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initialise)
    : initialise();
})();
